import { render, staticRenderFns } from "./top-panel.vue?vue&type=template&id=61244858&"
import script from "./top-panel.vue?vue&type=script&lang=js&"
export * from "./top-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports